import axios from 'axios';

import { addQueryParams, buildEndpoint, getAuthToken } from '@services/service';

const BASE_URL = process.env.REACT_APP_PAYMENTS_URL as string;

const searchCoupons = async (query: string, limit = 10) => {
    try {
        const queryParams = addQueryParams({ query, limit });
        const endpoint = buildEndpoint(BASE_URL, `/api/admin/coupons/search`);
        const response = await axios.get(`${endpoint}${queryParams}`, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data;
    } catch (err) {
        console.error('Error searching coupons:', err);
        return [];
    }
};

export { searchCoupons };
